import type { Route } from '@components/AppRouter/types';

export const getPathsFromRoutes = (config: Route[]): (string | undefined)[] => {
  const arrOfRoutes = config.flatMap((el) => el?.routes).filter((item) => item);
  return (arrOfRoutes as Route[]).map((el) => el.path).filter((el) => el);
};
